<section class="box-border flex flex-col px-4 lg:px-6 xl:px-8 py-0 my-0 w-full" *ngIf="products.length > 0">
  <header class="flex flex-wrap gap-10 mb-3 sm:mb-4 mt-2 justify-between items-center w-full max-w-full">
    <h2 *ngIf="!isPartsforyou"
      class="text-2xl font-bold text-black leading-8 max-md:text-lg max-md:leading-7 max-sm:text-base max-sm:leading-6">
      Scrap Parts for you
    </h2>
    <h2 *ngIf="isPartsforyou && partType === false"
      class="text-2xl font-bold text-black leading-8 max-md:text-lg max-md:leading-7 max-sm:text-base max-sm:leading-6">
      Parts from the donor vehicle
    </h2>
    <h2 *ngIf="isPartsforyou && partType === true"
      class="text-2xl font-bold text-black leading-8 max-md:text-lg max-md:leading-7 max-sm:text-base max-sm:leading-6">
      More Products From This Seller
    </h2>
    <a (click)="viewall('your_vehicles')" *ngIf="products.length > 9"
      class="viewAll flex text-base font-bold text-blue-500 text-center leading-6 max-md:text-sm max-md:leading-5 max-sm:text-xs max-sm:leading-4 max-sm:mt-2 cursor-pointer">
      View all
    </a>
  </header>

  <div class="relative mb-3 sm:mb-6 md:mb-10 w-full">
    <!-- Carousel container -->
    <div class="overflow-hidden max-sm:overflow-x-auto max-sm:mx-2 custom-scrollbar-hide relative">
      <div class="flex gap-4 max-md:gap-2.5 max-sm:gap-2 transition-transform duration-300 ease-in-out px-0" [ngStyle]="{
          transform: 'translateX(-' + currentSlide * slideWidth + 'px)',
        }">
        <!-- Product card -->
        <article *ngFor="let product of products"
          class="seller-card flex flex-col bg-white rounded-lg shadow-sm flex-shrink-0 w-[calc(50%-6px)] min-w-[calc(50%-6px)] max-w-[calc(50%-6px)] sm:w-[240px] sm:min-w-[240px] sm:max-w-[240px] md:w-[220px] md:min-w-[220px] md:max-w-[220px] lg:w-[260px] lg:min-w-[260px] lg:max-w-[260px] xl:w-[300px] xl:min-w-[300px] xl:max-w-[300px]">
          <figure class="overflow-hidden self-stretch bg-white rounded-t-lg w-full">
            <div class="relative group w-full h-[220px] max-md:h-[135px] max-sm:h-[135px] cursor-pointer"
              (mouseenter)="onProductHover(product)" (mouseleave)="onProductHoverEnd()">
              <!-- Grade Badge -->
              <div *ngIf="product?.quality_s" [ngClass]="
                  product?.quality_s === 'A'
                    ? 'bg-green-100 text-green-800'
                    : product?.quality_s === 'B'
                      ? 'bg-yellow-100 text-yellow-800'
                      : product?.quality_s === 'C'
                        ? 'bg-orange-100 text-orange-800'
                        : 'bg-green-100 text-green-800'
                " class="absolute top-2 left-2 z-1 flex items-center px-2 py-1 rounded shadow font-bold text-xs">
                <svg width="20" height="20" class="mr-1">
                  <rect width="20" height="20" rx="4" [attr.fill]="
                      product?.quality_s === 'A'
                        ? '#01811D'
                        : product?.quality_s === 'B'
                          ? '#B8860B'
                          : product?.quality_s === 'C'
                            ? '#D35400'
                            : '#01811D'
                    " />
                  <text x="10" y="15" text-anchor="middle" font-size="12" font-family="Arial, sans-serif" fill="white">
                    {{ product.quality_s }}
                  </text>
                </svg>
                Quality
              </div>

              <!-- Left Arrow -->
              <button *ngIf="
                  hoveredProduct === product &&
                  product?.part_image_path?.length > 1
                " (click)="prevImage(product); $event.stopPropagation()"
                class="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
                <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
                  <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <!-- Product Image -->
              <img [src]="getCurrentImage(product)" [alt]="product?.table_name"
                class="object-cover bg-zinc-100 rounded-t-lg w-full h-full cursor-pointer"
                (click)="gotoProductDetails(product)" />

              <!-- Right Arrow -->
              <button *ngIf="
                  hoveredProduct === product &&
                  product?.part_image_path?.length > 1
                " (click)="nextImage(product); $event.stopPropagation()"
                class="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
                <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
                  <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <!-- Carousel Dots -->
              <div *ngIf="
                  hoveredProduct === product &&
                  product?.part_image_path?.length > 1
                " class="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 z-10 group-hover:flex hidden">
                <span *ngFor="let img of product?.part_image_path; let i = index" class="w-3 h-1.5 rounded-full"
                  [ngClass]="{
                    'bg-gray-400': i !== product.currentImageIndex,
                    'bg-white border border-gray-400':
                      i === product.currentImageIndex,
                  }"></span>
              </div>
            </div>
          </figure>

          <div class="flex flex-col flex-1 p-3 max-md:p-2 w-full text-base min-h-0">
            <h3 (click)="gotoProductDetails(product)"
              class="font-bold text-base max-md:text-xs leading-tight line-clamp-2 cursor-pointer max-sm:min-h-0 md:min-h-[2.5em]">
              {{ product.table_name }}
            </h3>

            <div class="flex flex-col gap-1.5 max-sm:gap-1 text-sm cursor-pointer" *ngIf="partType">
              <div class="flex flex-col text-sm">
                <p class="justify-start text-Text-Black">
                  <span class="text-xs max-md:text-[10px] font-medium leading-none">{{ product?.scrap_category }}</span>
                </p>

                <p class="text-gray-600 text-sm max-md:text-[11px] break-words">
                  Seller:
                  <span class="text-[#0A0A5F] font-bold">{{
                    product?.seller_name
                    }}</span>
                </p>
              </div>
              <!-- <p class="text-gray-600  whitespace-nowrap" (click)="gotoProductDetails(product)">
                      Seller: <span class="text-[#0A0A5F] text-[14px] font-bold leading-[20px]">{{product?.seller_name}}</span>
                    </p> -->
              <div class="flex flex-wrap items-center gap-2 max-md:gap-1" (click)="gotoProductDetails(product)">
                <p class="text-black text-sm max-md:text-[12px] font-bold">
                  ₹{{
                  product?.discounted_taxable
                  ? product?.discounted_taxable
                  : product?.taxable_amount
                  }}/<ng-container
                    *ngIf="isOilProductWithLiter(product); else showKgPrice">Ltr</ng-container><ng-template
                    #showKgPrice>Kg</ng-template>
                </p>
                <p class="text-[#777] line-through text-[12px] max-md:text-[10px] font-medium leading-[16px] max-sm:block"
                  *ngIf="product?.discount_percentage > 0">
                  ₹{{ product?.taxable_amount }}
                </p>
                <span
                  class="flex items-center justify-center gap-1 p-[6px] rounded-[10px] bg-[#006C3B] text-white text-[10px] max-md:text-[9px] font-bold leading-[12.487px] whitespace-nowrap"
                  *ngIf="
                    product?.discount_percentage &&
                    product?.discount_percentage > 0
                  ">
                  {{ product?.discount_percentage }}% off
                </span>
              </div>

              <div
                class="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs max-md:text-[10px] text-gray-500 mt-1 max-sm:mt-0.5 break-words"
                (click)="gotoProductDetails(product)">
                <p>
                  Min Booking Qty:
                  <span class="text-black text-sm max-md:text-[11px] font-bold">
                    <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                      product?.min_quantity || product?.min_qty || 0
                      }}
                      kg</ng-container>
                    <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                      (product?.min_quantity || product?.min_qty || 0) / 1000
                      }}
                      ton</ng-container>
                    <ng-container *ngIf="
                        product.selectedUnit === 'liter' ||
                        isOilProductWithLiter(product)
                      ">{{
                      product?.min_quantity || product?.min_qty || 0
                      }}
                      ltr</ng-container>
                  </span>
                </p>
                <p>
                  Max Booking Qty:
                  <span class="text-black text-sm max-md:text-[11px] font-bold">
                    <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                      product.max_booking_qty ||
                      product.max_booking_quantity ||
                      product.max_quantity ||
                      product.available_quantity ||
                      product.fix_quantity ||
                      0
                      }}
                      kg</ng-container>
                    <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                      (product.max_booking_qty ||
                      product.max_booking_quantity ||
                      product.max_quantity ||
                      product.available_quantity ||
                      product.fix_quantity ||
                      0) / 1000
                      }}
                      ton</ng-container>
                    <ng-container *ngIf="
                        product.selectedUnit === 'liter' ||
                        isOilProductWithLiter(product)
                      ">{{
                      product.max_booking_qty ||
                      product.max_booking_quantity ||
                      product.max_quantity ||
                      product.available_quantity ||
                      product.fix_quantity ||
                      0
                      }}
                      ltr</ng-container>
                  </span>
                </p>
              </div>

              <div class="product-card-qty-box mt-1.5 max-sm:mt-1">
                <!-- Quantity selection based on unit -->
                <div *ngIf="
                    !product.selectedUnit || product.selectedUnit === 'ton'
                  " class="flex flex-1 min-w-0">
                  <!-- Show select dropdown when not in custom mode -->
                  <select *ngIf="product.quantity !== 'custom'" (change)="onTonQuantitySelect(product, $event)"
                    [value]="product.quantity || ''"
                    class="qty-dropdown">
                    <option value="" [selected]="!product.quantity">
                      Select any one
                    </option>
                    <option value="10" *ngIf="!isOilProductWithLiter(product)">
                      10
                    </option>
                    <option value="15" *ngIf="!isOilProductWithLiter(product)">
                      15
                    </option>
                    <option value="20" *ngIf="!isOilProductWithLiter(product)">
                      20
                    </option>
                    <option value="25" *ngIf="!isOilProductWithLiter(product)">
                      25
                    </option>
                    <option value="50" *ngIf="!isOilProductWithLiter(product)">
                      50
                    </option>
                    <option value="custom" *ngIf="!isOilProductWithLiter(product)">
                      Custom
                    </option>
                  </select>
                  <!-- Show input field when custom is selected -->
                  <input *ngIf="product.quantity === 'custom'" type="number" placeholder="Enter quantity"
                    [value]="product.customTonQuantity || ''" (input)="onCustomTonQuantityInput(product, $event)"
                    (blur)="onCustomTonQuantityBlur(product, $event)" [id]="'customInput-' + product.part_number"
                    class="qty-input"
                    min="1" step="0.1" />
                </div>
                <div *ngIf="product.selectedUnit === 'kg'" class="flex flex-1 min-w-0">
                  <input type="number" placeholder="Enter quantity" [value]="product.customKgQuantity || ''"
                    (input)="onKgQuantityChange(product, $event)"
                    class="qty-input"
                    min="1" step="1" />
                </div>
                <div *ngIf="
                    product.selectedUnit === 'liter' ||
                    isOilProductWithLiter(product)
                  " class="flex flex-1 min-w-0">
                  <input type="number" placeholder="Enter quantity" [value]="product.customLiterQuantity || ''"
                    (input)="onLiterQuantityChange(product, $event)"
                    class="qty-input"
                    min="1" step="1" />
                </div>
                <div *ngIf="
                    product.selectedUnit === 'liter' ||
                    isOilProductWithLiter(product)
                  " class="flex flex-1 min-w-0">
                  <input type="number" placeholder="Enter quantity" [value]="product.customLiterQuantity || ''"
                    (input)="onLiterQuantityChange(product, $event)"
                    class="qty-input"
                    min="1" step="1" />
                </div>

                <div class="unit-divider"></div>

                <select
                  class="unit-dropdown"
                  (change)="onUnitChange(product, $event)" [value]="product.selectedUnit || 'ton'">
                  <option value="ton" *ngIf="!isOilProductWithLiter(product)">
                    ton
                  </option>
                  <option value="kg" *ngIf="!isOilProductWithLiter(product)">
                    kg
                  </option>
                  <option value="liter" *ngIf="isOilProductWithLiter(product)">
                    ltr
                  </option>
                </select>
              </div>

              <span *ngIf="
                  product.quantityTouched &&
                  (getSelectedQuantity(product) === 0 ||
                    getSelectedQuantity(product) === null ||
                    getSelectedQuantity(product) === undefined)
                " class="mt-2 text-[10px] sm:text-xs text-red-600">
                Please select a quantity
              </span>
              <span *ngIf="
                  product.quantityTouched &&
                  getSelectedQuantity(product) > 0 &&
                  getSelectedQuantity(product) <
                    (product.min_quantity || product.min_qty || 0)
                " class="mt-2 text-[10px] sm:text-xs text-red-600">
                Minimum quantity is
                <ng-container *ngIf="
                    product.selectedUnit === 'kg' ||
                    (!product.selectedUnit && !isOilProductWithLiter(product))
                  ">{{
                  product.min_quantity || product.min_qty || 0
                  }}
                  kg</ng-container><ng-container *ngIf="product.selectedUnit === 'ton'">{{
                  (product.min_quantity || product.min_qty || 0) / 1000
                  }}
                  ton</ng-container><ng-container *ngIf="
                    product.selectedUnit === 'liter' ||
                    isOilProductWithLiter(product)
                  ">{{
                  product.min_quantity || product.min_qty || 0
                  }}
                  ltr</ng-container>
              </span>
              <span *ngIf="
                  product.quantityTouched &&
                  getSelectedQuantity(product) > 0 &&
                  getSelectedQuantity(product) >
                    (product.max_booking_qty ||
                      product.max_booking_quantity ||
                      product.max_quantity ||
                      product.available_quantity ||
                      product.fix_quantity ||
                      0)
                " class="mt-2 text-[10px] sm:text-xs text-red-600">
                Maximum available quantity is
                <ng-container *ngIf="
                    product.selectedUnit === 'kg' ||
                    (!product.selectedUnit && !isOilProductWithLiter(product))
                  ">{{
                  product.max_booking_qty ||
                  product.max_booking_quantity ||
                  product.max_quantity ||
                  product.available_quantity ||
                  product.fix_quantity ||
                  0
                  }} kg</ng-container>
                <ng-container *ngIf="product.selectedUnit === 'ton'">{{
                  (product.max_booking_qty ||
                  product.max_booking_quantity ||
                  product.max_quantity ||
                  product.available_quantity ||
                  product.fix_quantity ||
                  0) / 1000
                  }} ton</ng-container>
                <ng-container *ngIf="
                    product.selectedUnit === 'liter' ||
                    isOilProductWithLiter(product)
                  ">{{
                  product.max_booking_qty ||
                  product.max_booking_quantity ||
                  product.max_quantity ||
                  product.available_quantity ||
                  product.fix_quantity ||
                  0
                  }} ltr</ng-container>
              </span>
            </div>
            @if (!partType) {
            <div
              class="flex flex-wrap gap-1 mt-1.5 text-[var(--Text-Header,#464646)] text-xs max-md:text-[10px] leading-relaxed line-clamp-2 cursor-pointer"
              (click)="gotoProductDetails(product)">
              <span *ngIf="product?.make">{{ product?.make }}</span>
              <span *ngIf="product?.make">•</span>
              <span *ngIf="product?.model">{{
                product?.model | slice: 0 : 10
                }}</span>
              <span *ngIf="product?.model">•</span>
              <span *ngIf="product?.year_of_manufacture">{{
                product?.year_of_manufacture
                }}</span>
              <span *ngIf="product?.year_of_manufacture">•</span>
              <span *ngIf="product?.variant">{{
                product?.variant | slice: 0 : 10
                }}</span>
            </div>

            <div class="flex flex-wrap gap-2 items-baseline cursor-pointer" (click)="gotoProductDetails(product)">
              <span class="text-black text-[16px] max-md:text-[13px] font-bold leading-[24px]">
                ₹{{
                product?.discounted_price
                ? product?.discounted_price.toLocaleString()
                : product?.price_s.toLocaleString()
                }}
              </span>

              <span class="text-sm max-md:text-[11px] font-medium line-through text-gray-500" *ngIf="
                    product?.discounted_price &&
                    product?.price_s &&
                    product?.discount_percentage > 0
                  ">
                ₹{{ product?.price_s?.toLocaleString() }}
              </span>
              <div
                class="px-2 py-1 text-xs max-md:text-[9px] font-bold text-white bg-emerald-800 rounded-xl whitespace-nowrap"
                *ngIf="
                    product?.discounted_price &&
                    product?.price_s &&
                    product?.discount_percentage > 0
                  ">
                {{ product?.discount_percentage }}% Off
              </div>
            </div>

            <div
              class="flex flex-wrap gap-2 max-md:gap-1 justify-between items-center max-md:mt-2 w-full text-xs max-md:text-[10px] text-black cursor-pointer"
              (click)="gotoProductDetails(product)">
              <div class="flex gap-2 items-center">
                <div>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="max-sm:w-4 max-sm:h-4">
                    <path
                      d="M11.6666 15V8.33333M11.6666 15H13.3333M11.6666 15H8.74996M4.16663 15H5.41663M11.6666 8.33333V5.83333C11.6666 5.3731 11.2935 5 10.8333 5H4.16663C3.70639 5 3.33329 5.3731 3.33329 5.83333V7.5M11.6666 8.33333H15.1429C15.585 8.33333 16.0089 8.50893 16.3214 8.82149L17.8451 10.3452C18.1577 10.6577 18.3333 11.0817 18.3333 11.5237V14.1667C18.3333 14.6269 17.9602 15 17.5 15H16.6666M8.74996 15C8.74996 15.9205 8.00377 16.6667 7.08329 16.6667C6.16282 16.6667 5.41663 15.9205 5.41663 15M8.74996 15C8.74996 14.0795 8.00377 13.3333 7.08329 13.3333C6.16282 13.3333 5.41663 14.0795 5.41663 15M16.6666 15C16.6666 15.9205 15.9204 16.6667 15 16.6667C14.0795 16.6667 13.3333 15.9205 13.3333 15M16.6666 15C16.6666 14.0795 15.9204 13.3333 15 13.3333C14.0795 13.3333 13.3333 14.0795 13.3333 15M3.33329 7.5H6.66663M3.33329 7.5H1.66663M8.33329 10H3.33329M3.74996 12.5H2.49996"
                      stroke="#307FE1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <div class="flex gap-1 items-start">
                  <span class="font-medium" *ngIf="!isMobile">Delivery by</span>
                  <span class="font-bold">{{
                    product?.updated_at_dt | date: "mediumDate"
                    }}</span>
                </div>
              </div>
              <div class="flex gap-2 items-center">
                <div>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="max-sm:w-4 max-sm:h-4">
                    <path
                      d="M16.0869 8.93384V15C16.0869 16.3807 14.919 17.5 13.4782 17.5H12.1739M16.0869 8.93384C16.4191 8.76991 16.7513 8.52197 17.035 8.27813C17.5483 7.83698 17.627 7.11852 17.3187 6.52752L15.9384 3.88197C15.4965 3.03501 14.5932 2.5 13.6051 2.5H6.3949C5.4068 2.5 4.50351 3.03501 4.06162 3.88197L2.68134 6.52752C2.373 7.11852 2.45168 7.83698 2.96498 8.27813C3.24869 8.52197 3.58089 8.76991 3.91309 8.93384M16.0869 8.93384C15.8016 9.07464 15.5051 9.16667 15.2174 9.16667C13.4782 9.16667 12.6087 7.5 12.6087 7.5C12.6087 7.5 11.7391 9.16667 10 9.16667C8.26088 9.16667 7.39132 7.5 7.39132 7.5C7.39132 7.5 6.52176 9.16667 4.78264 9.16667C4.49494 9.16667 4.19841 9.07464 3.91309 8.93384M3.91309 8.93384V15C3.91309 16.3807 5.08103 17.5 6.52176 17.5H7.8261M7.8261 17.5V13.3333C7.8261 12.8731 8.21542 12.5 8.69566 12.5H11.3043C11.7846 12.5 12.1739 12.8731 12.1739 13.3333V17.5M7.8261 17.5H12.1739"
                      stroke="#307FE1" stroke-width="1.5" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <div class="font-medium" *ngIf="!isMobile">
                  Store pickup ready
                </div>
              </div>
            </div>
            }

            <div *ngIf="product?.is_locked"
              class="flex items-center gap-2 text-[#E30613] text-[12px] font-bold max-md:text-[8px]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="max-md:w-4 max-md:h-4" width="12"
                height="12">
                <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
                <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
                <circle cx="16" cy="23" r="2" fill="red" />
              </svg>
              <span>This part is no longer available for purchase.</span>
            </div>

            <div class="flex flex-row gap-1.5 mt-auto pt-3 max-md:pt-1.5 w-full font-bold text-center">
              <!-- Buy Now Button -->
              <app-buy-now-button [productData]="product" [isLocked]="product?.is_locked"
                (buyNowClicked)="onBuyNow(product)" (paymentSuccess)="onPaymentSuccess($event)" class="flex-1 min-w-0">
              </app-buy-now-button>

              <!-- Animated Cart Button -->
              <button [disabled]="product?.is_locked"
                class="cart-btn flex items-center justify-center gap-0.5 px-1 py-1.5 max-md:py-1 text-[10px] md:text-[11px] xl:text-sm flex-1 min-w-0 min-h-8 max-md:min-h-8 xl:min-h-10 bg-blue-500 rounded-lg"
                [class.added]="isProductAddedToCart(product)" [class.disabled]="product?.is_locked" (click)="
                  isProductAddedToCart(product)
                    ? goToCart($event)
                    : onAddToCartClicked($event, product)
                ">
                <div class="cart-content cart-content-add">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
                    class="cart-icon-svg w-3.5 h-3.5 xl:w-5 xl:h-5">
                    <rect width="20" height="20" transform="translate(0.5)" />
                    <path
                      d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-[10px] md:text-[11px] xl:text-sm font-bold text-white">Add to Cart</span>
                </div>
                <div class="cart-content cart-content-go">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    class="cart-icon-svg w-3.5 h-3.5 xl:w-5 xl:h-5">
                    <path
                      d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-[10px] md:text-[11px] xl:text-sm font-bold text-white">Go to Cart</span>
                </div>
              </button>
            </div>
          </div>
        </article>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <button *ngIf="products.length > visibleSlides && !isMobile"
      class="absolute left-0 md:left-2 top-[40%] -translate-y-1/2 z-10 max-sm:hidden flex justify-center items-center w-10 h-10 text-white bg-blue-500 rounded-lg shadow-md transition hover:-translate-x-0.5"
      [class.opacity-40]="currentSlide === 0" [class.cursor-not-allowed]="currentSlide === 0"
      [class.pointer-events-none]="currentSlide === 0" [disabled]="currentSlide === 0" (click)="prev()"
      aria-label="Previous slide">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15 18l-5.293-5.293a1 1 0 010-1.414L15 6" stroke="white" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <button *ngIf="products.length > visibleSlides && !isMobile"
      class="absolute right-0 md:right-2 top-[40%] -translate-y-1/2 z-10 max-sm:hidden flex justify-center items-center w-10 h-10 text-white bg-blue-500 rounded-lg shadow-md transition hover:translate-x-0.5"
      [class.opacity-40]="currentSlide >= products.length - visibleSlides"
      [class.cursor-not-allowed]="currentSlide >= products.length - visibleSlides"
      [class.pointer-events-none]="currentSlide >= products.length - visibleSlides"
      [disabled]="currentSlide >= products.length - visibleSlides" (click)="next()" aria-label="Next slide">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 6l5.293 5.293a1 1 0 010 1.414L9 18" stroke="white" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</section>

<!-- Buy Now Popup -->
<app-buy-now-popup [productData]="selectedProductForBuyNow" [isOpen]="isBuyNowPopupOpen"
  [quantity]="getQuantityForPopup(selectedProductForBuyNow)" [unit]="
    selectedProductForBuyNow?.selectedUnit === 'kg'
      ? 'Kg'
      : selectedProductForBuyNow?.selectedUnit === 'liter'
        ? 'Liter'
        : 'Ton'
  " (close)="closeBuyNowPopup()" (paymentSuccess)="onPaymentSuccess($event)">
</app-buy-now-popup>

<!-- Scrap Certificate Modal -->
<app-scrap-certificate-modal></app-scrap-certificate-modal>